/**
 * @description Custom ApiError exception
 */

class ApiError extends Error {
  constructor (message, body, status) {
    super(message);

    this.body = body;
    this.message = message;
    this.status = status;
  }

  getMessage () {
    return this.body ? `Error: ${ this.body }` : this.message;
  }
}

export default ApiError;
